/**
 * Piloto dual precio — sincroniza carrito (1 variante por producto) y atributo de ruta.
 */
(function () {
  const ROUTE_ATTR = 'armonia_checkout_route';

  async function fetchCart() {
    const url = (window.routes?.cart_url || '/cart') + '.js';
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  async function updateCart(body) {
    const res = await fetch((window.routes?.cart_update_url || '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    return res.ok;
  }

  function isPilotLine(item) {
    const pago = item.properties && item.properties._armonia_pago;
    return pago === 'contado' || pago === 'msi' || pago === 'openpay';
  }

  /** Quita la otra variante del mismo producto piloto antes de agregar. */
  async function preparePilotCart(productId, keepVariantId, mode) {
    const cart = await fetchCart();
    const updates = {};
    for (const item of cart.items) {
      if (item.product_id === productId && item.variant_id !== keepVariantId) {
        updates[item.key] = 0;
      }
    }
    const payload = { attributes: { [ROUTE_ATTR]: mode } };
    if (Object.keys(updates).length) payload.updates = updates;
    await updateCart(payload);
  }

  /** Si quedaron contado+MSI del mismo producto, deja solo la línea más reciente. */
  async function dedupePilotCart() {
    const cart = await fetchCart();
    const byProduct = {};
    for (const item of cart.items) {
      if (!isPilotLine(item)) continue;
      if (!byProduct[item.product_id]) byProduct[item.product_id] = [];
      byProduct[item.product_id].push(item);
    }
    const updates = {};
    for (const lines of Object.values(byProduct)) {
      if (lines.length <= 1) continue;
      const keep = lines[lines.length - 1];
      for (const line of lines) {
        if (line.key !== keep.key) updates[line.key] = 0;
      }
    }
    if (!Object.keys(updates).length) return false;
    await updateCart({ updates });
    return true;
  }

  async function setCheckoutRoute(mode) {
    await updateCart({ attributes: { [ROUTE_ATTR]: mode } });
  }

  window.armoniaPilotCart = {
    preparePilotCart,
    dedupePilotCart,
    setCheckoutRoute,
    ROUTE_ATTR,
  };
})();
